export const MAX_TOTAL_NAME_LENGTH = 64;
export const PREPAID_SQUARE_LIMIT = 100;
